import { EndpointKey } from '../http/EndpointKey';
import { updateVerificationExpired } from '../store/app/action-creators';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { handleCodeVerificationSuccess } from './handleCodeVerificationSuccess';
export const handleCodeVerificationRefreshSuccess = (response, dispatch) => {
  handleCodeVerificationSuccess(response, dispatch);
  dispatch(Tracker.signupInteraction('signup-error-verification-refreshed'));
  dispatch(updateVerificationExpired(false));
  dispatch(retryEndpoint(EndpointKey.Signup));
};